/**
 * PostHog Event Name Constants and Mappings
 */

// Identifies which sign up flow design a tracked event belongs to, so analytics
// can build A/B drop-off funnels comparing the old vs redesigned sign up flow.
export const LEGACY_SIGNUP_DESIGN_DATE = 202301;
export const REDESIGN_SIGNUP_DESIGN_DATE = 202604;

// Event names following pattern: [entity]:[category]:[action]
export const POSTHOG_EVENTS = {
  // Office Authentication Events
  OFFICE_AUTH_LOGIN_INITIATED: 'office:auth:login_initiated',
  OFFICE_AUTH_LOGIN_SUCCESS: 'office:auth:login_success',
  OFFICE_AUTH_LOGIN_FAILED: 'office:auth:login_failed',
  OFFICE_AUTH_LOGOUT: 'office:auth:logout',
  OFFICE_AUTH_SESSION_EXPIRED: 'office:auth:session_expired',

  // Office Logout Events
  OFFICE_LOGOUT_CLICKED: 'office:logout:clicked',
  OFFICE_LOGOUT_CONFIRMED: 'office:logout:confirmed',

  // Office Account Events
  OFFICE_ACCOUNT_UPDATED: 'office:account:updated',
  OFFICE_NOTIFICATION_TOGGLED: 'office:notification:toggled',

  // Office Calendar Events
  OFFICE_CALENDAR_NEXT_MONTH_CLICKED: 'office:calendar:next_month_clicked',
  OFFICE_CALENDAR_PREVIOUS_MONTH_CLICKED: 'office:calendar:previous_month_clicked',
  OFFICE_CALENDAR_POST_SHIFT_CLICKED: 'office:calendar:post_shift_clicked',
  OFFICE_CALENDAR_VIEW_SHIFT_DETAILS: 'office:calendar:view_shift_details',

  // Office Login Events
  OFFICE_LOGIN_FORGOT_PASSWORD_CLICKED: 'office:login:forgot_password_clicked',
  OFFICE_LOGIN_LOGIN_TAB_CLICKED: 'office:login:login_tab_clicked',

  // Office Password Reset Events
  OFFICE_RESET_PASSWORD_CODE_REQUESTED: 'office:reset_password:code_requested',

  // Office Auto-Confirm Events
  OFFICE_AUTO_CONFIRM_TOGGLED: 'office:auto_confirm:toggled',

  // Dental Portal Permanent Hire Request Events
  DENTAL_PORTAL_DASHBOARD_PERM_REQUEST_CLICKED: 'dental_portal:dashboard:perm_request_clicked',

  // Navigation Events
  NAV_PAGE_VIEWED: 'app:navigation:page_viewed',

  // Error Events
  ERROR_BOUNDARY_TRIGGERED: 'app:error:boundary_triggered',

  DENTAL_PORTAL_LOGIN_LOGIN_TAB_CLICKED: 'dental_portal:login:login_tab_clicked',
  DENTAL_PORTAL_LOGIN_SIGNUP_TAB_CLICKED: 'dental_portal:login:signup_tab_clicked',
  DENTAL_PORTAL_OFFICE_SIGNUP_CLICKED: 'dental_portal:office_signup:signup_clicked',
  DENTAL_PORTAL_OFFICE_SIGNUP_CONTACT_INFO_SUBMITTED:
    'dental_portal:office_signup:contact_info_submitted',
  DENTAL_PORTAL_OFFICE_SIGNUP_GENERAL_OFFICE_INFO_SUBMITTED:
    'dental_portal:office_signup:general_office_info_submitted',
  DENTAL_PORTAL_OFFICE_SIGNUP_GENERAL_OFFICE_INFO_COMPLETED:
    'dental_portal:office_signup:general_office_info_completed',
  DENTAL_PORTAL_OFFICE_SIGNUP_GENERAL_OFFICE_INFO_FAILED:
    'dental_portal:office_signup:general_office_info_failed',
  DENTAL_PORTAL_MFA_CODE_COMPLETED: 'dental_portal:mfa:code_completed',
  DENTAL_PORTAL_MFA_CODE_FAILED: 'dental_portal:mfa:code_failed',
  DENTAL_PORTAL_OFFICE_SIGNUP_ADDITIONAL_OFFICE_INFO_SUBMITTED:
    'dental_portal:office_signup:additional_office_info_submitted',
  DENTAL_PORTAL_OFFICE_SIGNUP_WORKER_TYPE_SUBMITTED:
    'dental_portal:office_signup:worker_type_submitted',
  DENTAL_PORTAL_OFFICE_SIGNUP_WORKER_TYPE_COMPLETED:
    'dental_portal:office_signup:worker_type_completed',
  DENTAL_PORTAL_OFFICE_SIGNUP_WORKER_TYPE_FAILED: 'dental_portal:office_signup:worker_type_failed',
  DENTAL_PORTAL_OFFICE_SIGNUP_WORKER_TYPE_PENDING:
    'dental_portal:office_signup:worker_type_pending',
  DENTAL_PORTAL_OFFICE_SIGNUP_COMPLETED: 'dental_portal:office_signup:completed',

  OFFICE_CALENDAR_SHIFT_REQUEST_CLICKED: 'dental_portal:calendar:shift_request_clicked',
  OFFICE_EMPTY_STATE_SHIFT_REQUEST_CLICKED: 'dental_portal:empty_state:shift_request_clicked',
} as const;

// Map Redux action types to PostHog events
export const REDUX_TO_POSTHOG_EVENT_MAP: Record<string, string> = {
  // Authentication mappings
  LOGIN_REQUEST: POSTHOG_EVENTS.OFFICE_AUTH_LOGIN_INITIATED,
  LOGIN_SUCCESS: POSTHOG_EVENTS.OFFICE_AUTH_LOGIN_SUCCESS,
  LOGIN_FAILURE: POSTHOG_EVENTS.OFFICE_AUTH_LOGIN_FAILED,
  LOGOUT_ACTION: POSTHOG_EVENTS.OFFICE_AUTH_LOGOUT,
  LOGOUT_ACTION_SUCCESS: POSTHOG_EVENTS.OFFICE_AUTH_LOGOUT,
};
